import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from '../containers/user-container/reducer/userSlice';
import filterReducer from '../containers/app-container/reducer/filterSlice';
import visibleColumnsReducer from '../containers/app-container/reducer/visibleColumnsSlice';
import themeReducer from '../containers/app-container/reducer/themeSlice';
import authReducer from '../containers/auth-container/reducer/authSlice';
import chatReducer from '../containers/chat-container/reducer/socketSlice';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['chat','filter'],
};

const visibleColumnsPersistConfig = {
  key: 'visibleColumns',
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  filter: filterReducer,
  theme: themeReducer,
  auth: authReducer,
  chat: chatReducer,
  visibleColumns: persistReducer(
    visibleColumnsPersistConfig,
    visibleColumnsReducer
  ),
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
// export const persistor = store;
